export class ConversationRemoteRepository {
    constructor(fetcher, contextId) {
        this.fetcher = fetcher;
        this.contextId = contextId;
    }
    async addConversation(conversation) {
        const request = await this.mapConversationToCreateRequest(conversation);
        const response = await this.fetcher.fetchPostJson(ConversationRemoteRepository.CONVERSATIONS_PATH, request);
        return ConversationRemoteRepository.applyConversationResponse(response);
    }
    async startConversation(conversation, operator) {
        const request = ConversationRemoteRepository.mapConversationToStartRequest(operator);
        const response = await this.fetcher.fetchPostJson(`${ConversationRemoteRepository.CONVERSATIONS_PATH}/${conversation.id}/start`, request);
        return ConversationRemoteRepository.applyConversationResponse(response);
    }
    async pauseConversation(conversation) {
        const response = await this.fetcher.fetchPostJson(`${ConversationRemoteRepository.CONVERSATIONS_PATH}/${conversation.id}/pause`);
        return ConversationRemoteRepository.applyConversationResponse(response);
    }
    async unpauseConversation(conversation) {
        const response = await this.fetcher.fetchPostJson(`${ConversationRemoteRepository.CONVERSATIONS_PATH}/${conversation.id}/unpause`);
        return ConversationRemoteRepository.applyConversationResponse(response);
    }
    async endConversation(conversation) {
        const response = await this.fetcher.fetchPostJson(`${ConversationRemoteRepository.CONVERSATIONS_PATH}/${conversation.id}/end`);
        return ConversationRemoteRepository.applyConversationResponse(response);
    }
    async archiveConversation(conversation) {
        const response = await this.fetcher.fetchPostJson(`${ConversationRemoteRepository.CONVERSATIONS_PATH}/${conversation.id}/archive`);
        return ConversationRemoteRepository.applyConversationResponse(response);
    }
    async reassignConversation(conversation, targetSession) {
        const request = ConversationRemoteRepository.mapConversationToMoveRequest(targetSession);
        const response = await this.fetcher.fetchPostJson(`${ConversationRemoteRepository.CONVERSATIONS_PATH}/${conversation.id}/reassign`, request);
        return ConversationRemoteRepository.applyConversationResponse(response);
    }
    static applyConversationResponse(response) {
        return ConversationRemoteRepository.mapResponseToConversation(response);
    }
    async mapConversationToCreateRequest(conversation) {
        return {
            id: conversation.id,
            contextId: this.contextId,
            clientId: conversation.client.id
        };
    }
    static mapConversationToStartRequest(operator) {
        return {
            operatorId: operator.id
        };
    }
    static mapConversationToMoveRequest(operator) {
        return {
            operatorId: operator.id
        };
    }
    static mapResponseToConversation(response) {
        return {
            id: response.id,
            client: response.client,
            operator: response.operator,
            createDate: new Date(response.createDate),
            startDate: response.startDate ? new Date(response.startDate) : undefined,
            pauseDate: response.pauseDate ? new Date(response.pauseDate) : undefined,
            endDate: response.endDate ? new Date(response.endDate) : undefined,
            archiveDate: response.archiveDate ? new Date(response.archiveDate) : undefined,
        };
    }
}
ConversationRemoteRepository.CONVERSATIONS_PATH = '/api/conversations';
